import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate('/library');
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        background: 'var(--bg-base)',
        position: 'relative',
      }}
    >
      <div
        className="glass-panel"
        style={{
          maxWidth: '480px',
          width: '100%',
          padding: '40px 32px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
        }}
      >
        <div
          style={{
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            background: 'rgba(239, 68, 68, 0.1)',
            border: '2px solid var(--status-error)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--status-error)',
            boxShadow: '0 0 20px rgba(239, 68, 68, 0.2)',
          }}
        >
          <XCircle size={40} />
        </div>

        <div>
          <h1 style={{ fontSize: '28px', fontWeight: 800, marginBottom: '8px', color: '#fff' }}>
            Checkout Cancelled
          </h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: '15px', lineHeight: '1.6' }}>
            Your transaction was not completed, and you have not been charged. If you experienced any issues, please try again or contact support.
          </p>
        </div>

        <button
          onClick={handleReturn}
          className="btn btn-secondary"
          style={{
            width: '100%',
            padding: '14px 28px',
            borderRadius: '24px',
            fontSize: '15px',
            marginTop: '8px',
          }}
        >
          <ArrowLeft size={16} />
          <span>Return to Dashboard</span>
        </button>
      </div>
    </div>
  );
};
